import React from 'react';
import './styles.css';

const MenuToggle = props => {
  const togglerClasses = props.toggled
    ? 'menu-toggle menu-toggle--toggled'
    : 'menu-toggle';

  return (
    <button className={togglerClasses} onClick={props.toggleFunc}>
      <span className="menu-toggle__line menu-toggle__line--1" />
      <span className="menu-toggle__line menu-toggle__line--2" />
      <span className="menu-toggle__line menu-toggle__line--3" />
    </button>
  );
};

export default MenuToggle;
